import BaseReducer from '../../../../../../../reducers/base-reducer';
import {
    PaginatedResultReducer,
    paginatedResultInitialState
} from '../../../../../../../reducers/common/paginated-result-reducer';
import types from '../../../../../../../actions/types';

class DebtsReducer extends BaseReducer {
    constructor() {
        super();
        this.initialState = {
            games: paginatedResultInitialState
        };
        this.ACTION_HANDLERS = {
            ...new PaginatedResultReducer(types.GET_GAMES, 'games').ACTION_HANDLERS
        };
    }
}

export default new DebtsReducer().handleActions;



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/main/modules/games-main-reducer.js